import axios from 'axios';
import { CORE_API } from '../env.config.js';

/**
 * Deletes a file upload from the server
 * @param {Object} coreToken - The core token object with token
 * @param {string} fileUploadId - The ID of the file upload to delete
 * @returns {Promise} Axios response
 */
const deleteFileUpload = async (coreToken, fileUploadId) => {
  const baseURL = CORE_API;

  try {
    const response = await axios.delete(
      `file_uploads/${fileUploadId}`,
      {
        baseURL,
        params: {
          group_id: coreToken.provider_id,
        },
        headers: {
          Authorization: `Bearer ${coreToken.token}`,
          'X-Application-Source': 'widgets',
        },
      },
    );

    return response;
  } catch (error) {
    return error;
  }
};

export default deleteFileUpload;
